import { fetchListingCollections } from '../../ducks/listingCollections.duck';
import { COLLECTION_SOURCES } from '../../util/listingCollections';
import { CATEGORY_KEYS, CATEGORY_LEVEL_1 } from '../../util/categories';

const CARD_LIMIT = 12;

/**
 * The collection descriptor for one category, or null for an unknown slug.
 *
 * @param {string} slug category slug from the URL
 * @returns {Object|null}
 */
export const categoryCollection = slug => {
  const key = CATEGORY_KEYS[slug];
  if (!key) {
    return null;
  }
  return {
    id: `category-${slug}`,
    source: COLLECTION_SOURCES.QUERY,
    params: { pub_categoryLevel1: CATEGORY_LEVEL_1, pub_categoryLevel2: key },
    limit: CARD_LIMIT,
  };
};

export const loadData = (params, search, config) => dispatch => {
  const collection = categoryCollection(params.slug);
  if (!collection) {
    return Promise.resolve();
  }
  // Server-rendered, so the cards ship as crawlable links. The static pages
  // fetched these client-side with an empty client id, so the grid never
  // rendered at all - this is also the fix for that.
  return dispatch(fetchListingCollections([collection], { config }));
};

export { CATEGORY_KEYS };
